import StateEngine from './state-engine';
import ErrorHandler from './error-handler';

class TreatmentStepHelper {

    constructor(params) {
        this.debug = false;
        this.lastOrder = typeof params.lastOrder !== 'undefined' ? parseInt(params.lastOrder): 0;
        this.variations = typeof params.variations === 'boolean' ? params.variations : false;
        this.validation = typeof params.validation === 'boolean' ? params.validation : true;
        this.language = typeof params.language === 'string' ? params.language : window.app.$store.state.language;
        this.currency = typeof params.currency === 'string' ? params.currency : window.app.$store.state.currency;
        this.steps = [];
        this.error = null;
        this.allowOnSurface = [1,3,4,5,27,906,907,207,208];
        this.childs = typeof params.params !== 'undefined' && typeof params.params.childs !== 'undefined' && Array.isArray(params.params.childs) && params.params.childs.length > 0 ? params.params.childs : null;
    }

    add(stateIds, selectedTeeth, selectedParts, params) {
        try {
            this.addStep(stateIds, selectedTeeth, selectedParts, params);
            if(this.error !== null) return false;
            return true;
        } catch (error) {
            captureException(error);
            let context = {
                stateIds: typeof stateIds !== 'undefined' ? stateIds : 'undefined',
                selectedTeeth: typeof selectedTeeth !== 'undefined' ? selectedTeeth : 'undefined',
                selectedParts: typeof selectedTeeth !== 'undefined' ? selectedTeeth : 'undefined',
                params: typeof params !== 'undefined' ? params : 'undefined'
            };
            if(this.debug) this.error = error.message;
            else this.error = 'General error';
            ErrorHandler.log(error, context);
            return false;
        }
    }

    getSteps() {
        return this.steps;
    }

    getError() {
        return this.error;
    }

    buildSelection(selectedTeeth, selectedParts) {
        if(typeof(selectedTeeth)==='undefined') selectedTeeth = [];
        if(typeof(selectedParts)==='undefined') selectedParts = [];
        let selection = [];
        let teeth = [];

        for(let i in selectedParts) {
            selection.push({
                tooth_id: parseInt(selectedParts[i].tooth_id),
                surface: JSON.parse(JSON.stringify(selectedParts[i].parts))
            });
            teeth.push(parseInt(selectedParts[i].tooth_id));
        }

        for(let i in selectedTeeth) {
            // Skip if already added as part
            if(teeth.indexOf(parseInt(selectedTeeth[i]))>=0) continue;
            selection.push({
                tooth_id: parseInt(selectedTeeth[i]),
                surface: null
            });
        }

        return selection;
    }

    validateStep(stateIds) {

        for(let s in stateIds) {
            let id = parseInt(stateIds[s]);

            switch(id) {
                case 17:
                case 18:
                    for(let i in this.selection) {
                        let toothId = parseInt(this.selection[i].tooth_id);
                        if([11,12,13,21,22,23,31,32,33,41,42,43].indexOf(toothId)>0) {
                            this.error = 'invalid_treatment';
                            return false;
                        }
                    }
                    break;
                case 905:
                    for(let i in this.selection) {
                        let toothId = parseInt(this.selection[i].tooth_id);
                        if([18,28,38,48].indexOf(toothId)<0) {
                            this.error = 'invalid_treatment';
                            return false;
                        }
                        let status = StateEngine.getToothStatus(toothId);
                        if(parseInt(status['root'])!== 1 && parseInt(status['root'])!== 201) {
                            this.error = 'invalid_treatment';
                            return false;
                        }
                    }
                    break;
                case 911:
                    if(this.selection.length === 0) {
                        this.error = 'allow_sinus_lift_info';
                        return false;
                    }
                    for(let i in this.selection) {
                        let toothId = parseInt(this.selection[i].tooth_id);
                        if([17,16,15,25,26,27].indexOf(toothId)<0) {
                            this.error = 'allow_sinus_lift_info';
                            return false;
                        }
                    }
                    break;
            }

            var pid = window.app.$store.getters.dentalStateById(id).parent_id;
            if(parseInt(pid) !== 202 && this.selectedTeeth.length===0 && this.selectedParts.length===0 ) {
                this.error = 'select_tooth';
                return false;
            }

            let selectedTeeth = [];
            for(let i in this.selection) {
                selectedTeeth.push(parseInt(this.selection[i].tooth_id));
            }
            if(!StateEngine.isAllowed(pid, selectedTeeth)) {

                if(this.debug) Debug.info('Not allowed '+ pid);

                var odontogramEl = document.getElementById('pm-odontogram-container');
                if(typeof odontogramEl !=='undefined' && odontogramEl !== null) {
                    odontogramEl.classList.add('blink');
                    window.setTimeout(function() {
                        odontogramEl.classList.remove('blink');
                    },1000);
                }
                this.error = 'invalid_treatment';
                return false;
            }
        }
        return true;
    }


    /**
     * Add treatment(s) to the selected teeth
     **/
    addStep(stateIds, selectedTeeth, selectedParts, params) {
        if(typeof(stateIds)!=='object') stateIds = [stateIds];
        if(typeof(params)!=='object') params = {};
        if(this.debug) Debug.info('AddStep',stateIds, selectedTeeth, selectedParts);

        this.selectedTeeth = selectedTeeth;
        this.selectedParts = selectedParts;

        for(let i in stateIds) {
            let stateId = stateIds[i];
            let originalSelection = [];
            let filteredSelection = StateEngine.filterBeforeAdd(stateId,selectedTeeth);
            this.selection = this.buildSelection(filteredSelection, selectedParts);

            for(let i in this.selection) {
                originalSelection.push(this.selection[i].tooth_id);
            }

            if(this.validation === true && !this.validateStep(stateIds)) return false;

            let pid = window.app.$store.getters.dentalStateById(stateId).parent_id;
            // If parts selected add distinct step for each teeth
            if(this.allowOnSurface.indexOf(parseInt(pid))>=0 && typeof(selectedParts)==='object' && selectedParts !== null && selectedParts.length > 0) {
                for(let j in this.selection) {
                    this.addStepWithVariations(Object.assign(params,{ stateId: stateId, selection: [this.selection[j].tooth_id], surface: this.selection[j].surface }));
                }
            } else {
                let splittedSelection = window.Helper.splitJaws(originalSelection);
                if(splittedSelection.upper.length > 0) {
                    this.jaw = 'upper';
                    this.addStepWithVariations(Object.assign(params,{ stateId: stateId, selection: splittedSelection.upper }));
                }
                if(splittedSelection.lower.length > 0) {
                    this.jaw = 'lower';
                    this.addStepWithVariations(Object.assign(params,{ stateId: stateId, selection: splittedSelection.lower }));
                }
                if(splittedSelection.upper.length === 0 && splittedSelection.lower.length === 0) {
                    this.addStepWithVariations(Object.assign(params,{ stateId: stateId, selection: originalSelection }));
                }
            }
        }
        return true;
    }

    getStepData(stateId, selectedTeeth, forcedPrice) {
        this.lastOrder++;
        var data = window.app.$store.getters.stepData({
            stateId: stateId,
            selectedTeeth: StateEngine.filterBeforeAdd(stateId,selectedTeeth),
            ordering: this.lastOrder,
            language: this.language,
            currency: this.currency,
            forcedPrice: (typeof(forcedPrice)!=='undefined') ? forcedPrice : null
        });
        data.jaw = window.Helper.getJaw(selectedTeeth);
        data.selected = true;
        data.active = true;
        if(parseInt(stateId) === 99) {
            data.phase_value_min = 0;
            data.phase_value_max = 0;
            data.phase_pay_set = false;
            data.phase_pay_min = 0;
            data.phase_pay_max = 0;
            data.is_last_phase = false;
        }
        if([8,14,17,19,23,25,200].indexOf(parseInt(data.state_pid))>=0 && data.price === 0) data.billable = 0;
        if(this.debug) Debug.info('Get step data', data);
        return data;
    }

    countSurfaces(surfaces) {
        if(surfaces === null || typeof (surfaces)!=='object') return 0;
        let l = surfaces.length;
        if(surfaces.indexOf('O1')>=0 && surfaces.indexOf('O2')>=0) l--;
        return l;
    }

    countRoots(toothId) {
        if([18,17,16,26,27,28].indexOf(parseInt(toothId))>=0) return 3;
        else if([38,37,36,46,47,48,14,24].indexOf(parseInt(toothId))>=0) return 2
        return 1;
    }

    getChilds(id) {
        try {
            id = parseInt(id);
            let childIds = [];
            if(id === 9 && app.$store.state.localSettings.config.plan_auto_crown_options !== '1') return [];
            if((id === 10 || id === 11) && app.$store.state.localSettings.config.plan_auto_implant_options !== '1') return [];
            if(id === 15 && app.$store.state.localSettings.config.plan_auto_bridge_options !== '1') return [];
            for (let i in window.app.$store.state.dentalStates) {
                if (parseInt(window.app.$store.state.dentalStates[i].parent_id) === id && parseInt(window.app.$store.state.dentalStates[i].id) > 1000 ) childIds.push(parseInt(window.app.$store.state.dentalStates[i].id));
            }
            return childIds;
        } catch(error) {
            captureException(error);
            return [];
        }
    }

    /**
     * Add all variation for treatment type
     * stateId: id of the state to add
     * selection
     * idx: index of the plan where the step should be added
     * forcedPrice: ignore price calculation
     */
    addStepWithVariations(params) {
        try {
            let stateId = params.stateId;
            let selection = params.selection;
            let idx = params.idx;
            //let forcedPrice = typeof(params.forcedPrice)!=='undefined' ? params.forcedPrice : null ;
            if (typeof (params.forcedPrice) === 'undefined') params.forcedPrice = null;
            if (typeof (params.billable) === 'undefined') params.billable = null;
            if (typeof (params.animate) === 'undefined') params.animate = null;
            if (typeof (params.surface) === 'undefined') params.surface = null;

            if (this.debug) window.Debug.info('Get step variations', {
                stateId: stateId,
                selection: selection,
                forcedPrice: params.forcedPrice
            });

            var childCount = 0,
                childId = null,
                stepData = {};
            var pid = window.app.$store.getters.dentalStateById(stateId).parent_id;

            var defaultChilds = {
                '9': [946, 947, 948],
                '15': [950, 951, 952],
                '11': [954, 955, 956],
                '930': [957, 958, 959],
            };

            if(this.childs !== null) {
                childCount = this.childs.length;
                defaultChilds[String(pid)] = this.childs;
            } else if ([10, 11, 9, 15, 930].indexOf(parseInt(pid)) >= 0) {
                defaultChilds[String(pid)] = this.getChilds(pid);
                for (let j in defaultChilds[String(pid)]) {
                    if (parseInt(stateId) === 949 || parseInt(stateId) === 953) break;
                    if (parseInt(window.app.$store.state.dentalStates[String(defaultChilds[String(pid)][j])].available_smart) > 0) {
                        childId = defaultChilds[String(pid)][j];
                        childCount++;
                    }
                }
            }

            if (childCount === 0 || !this.variations) {
                // No child found, add as normal step
                let surfaces = this.countSurfaces(params.surface);
                let newIds = [];
                switch (parseInt(stateId)) {
                    case 27: // Filling - normal
                        if (surfaces === 1) newIds.push({'stateId': 931, selection: selection});
                        if (surfaces === 2) newIds.push({'stateId': 932, selection: selection});
                        if (surfaces === 3) newIds.push({'stateId': 933, selection: selection});
                        if (surfaces === 4) newIds.push({'stateId': 934, selection: selection});
                        if (surfaces === 5) newIds.push({'stateId': 935, selection: selection});
                        break;
                    case 906: // Filling - small
                        if (surfaces === 1) newIds.push({'stateId': 936, selection: selection});
                        if (surfaces === 2) newIds.push({'stateId': 937, selection: selection});
                        if (surfaces === 3) newIds.push({'stateId': 938, selection: selection});
                        if (surfaces === 4) newIds.push({'stateId': 939, selection: selection});
                        if (surfaces === 5) newIds.push({'stateId': 940, selection: selection});
                        break;
                    case 907: // Filling - large
                        if (surfaces === 1) newIds.push({'stateId': 941, selection: selection});
                        if (surfaces === 2) newIds.push({'stateId': 942, selection: selection});
                        if (surfaces === 3) newIds.push({'stateId': 943, selection: selection});
                        if (surfaces === 4) newIds.push({'stateId': 944, selection: selection});
                        if (surfaces === 5) newIds.push({'stateId': 945, selection: selection});
                        break;
                    case 201: // Root canal treatment
                        for (let t in selection) {
                            let roots = this.countRoots(selection[t]);
                            if (roots === 3) newIds.push({'stateId': 910, selection: [selection[t]]});
                            else if (roots === 2) newIds.push({'stateId': 909, selection: [selection[t]]});
                            else newIds.push({'stateId': 908, selection: [selection[t]]});
                        }
                        break;
                    case 916: // Root canal filling
                        for (let t in selection) {
                            let roots = this.countRoots(selection[t]);
                            if (roots === 3) newIds.push({'stateId': 919, selection: [selection[t]]});
                            else if (roots === 2) newIds.push({'stateId': 918, selection: [selection[t]]});
                            else newIds.push({'stateId': 917, selection: [selection[t]]});
                        }
                        break;
                    case 920: // Root canal filling
                        for (let t in selection) {
                            let roots = this.countRoots(selection[t]);
                            if (roots === 3) newIds.push({'stateId': 923, selection: [selection[t]]});
                            else if (roots === 2) newIds.push({'stateId': 922, selection: [selection[t]]});
                            else newIds.push({'stateId': 921, selection: [selection[t]]});
                        }
                        break;
                }

                if (newIds.length > 0) {
                    for (let i in newIds) {
                        stepData = this.getStepData(newIds[i].stateId, newIds[i].selection, params.forcedPrice);
                        if (params.forcedTitle) stepData.title = stepData.title_animation = params.forcedTitle;
                        if (params.billable !== null) stepData.billable = params.billable;
                        if (params.animate !== null) stepData.animate = params.animate;
                        if (params.surface !== null) stepData.surface = params.surface;
                        this.steps.push(JSON.parse(JSON.stringify(stepData)));
                    }
                } else {
                    stepData = this.getStepData(stateId, selection, params.forcedPrice);
                    if (params.forcedTitle) stepData.title = stepData.title_animation = params.forcedTitle;
                    if (params.billable !== null) stepData.billable = params.billable;
                    if (params.animate !== null) stepData.animate = params.animate;
                    if (params.surface !== null) stepData.surface = params.surface;
                    this.steps.push(JSON.parse(JSON.stringify(stepData)));
                }
            } else if (childCount === 1) {
                // Only one child found, add the child as normal step, ignore the group
                stepData = this.getStepData(childId, selection, params.forcedPrice);
                if (params.forcedTitle) stepData.title = stepData.title_animation = params.forcedTitle;
                if (params.billable !== null) stepData.billable = params.billable;
                if (params.animate !== null) stepData.animate = params.animate;
                if (params.surface !== null) stepData.surface = params.surface;
                this.steps.push(stepData);
            } else {
                // Add base step (group), get the ordering as identifier
                // Set forced price -> 0
                //var groupData = this.getStepData(pid, selection, 0);
                var groupData = this.getStepData(defaultChilds[String(pid)][0], selection, 0);


                if (params.forcedTitle) groupData.title_animation = params.forcedTitle;
                if (params.billable !== null) groupData.billable = params.billable;
                if (params.animate !== null) groupData.animate = params.animate;
                if (params.surface !== null) groupData.surface = params.surface;
                groupData.parent_id = groupData.id;
                this.steps.push(groupData);

                // Add all pricelist items with the same parent_id, set group_id
                // Set animate -> 0

                var tmpStates = [];
                for (let index in window.app.$store.state.dentalStates) {
                    if (window.app.$store.state.dentalStates.hasOwnProperty(index)) {
                        tmpStates.push(window.app.$store.state.dentalStates[index]);
                    }
                }
                // Sort by ordering
                tmpStates.sort(function (a, b) {
                    return (a.ordering > b.ordering) ? 1 : ((b.ordering > a.ordering) ? -1 : 0);
                });
                var childCounter = 0;

                for (let j in defaultChilds[String(pid)]) {
                    let state = window.app.$store.getters.dentalStateById(defaultChilds[String(pid)][j]);

                    if (parseInt(state.available_smart) === 0) continue;

                    stepData = this.getStepData(state.id, selection, params.forcedPrice);
                    if (params.surface !== null) stepData.surface = params.surface;
                    stepData.parent_id = groupData.id;
                    stepData.tooth_id = JSON.parse(JSON.stringify(groupData.tooth_id));
                    stepData.amount = groupData.amount;
                    stepData.animate = 0;
                    //if ((stateId == pid && childCounter == 0) || stateId == state.id) {
                    if (childCounter == 0) {
                        stepData.billable = "1";
                        stepData.selected = true;
                    } else {
                        stepData.billable = "0";
                        stepData.selected = false;
                    }
                    this.steps.push(stepData);
                    childCounter++;
                }
            }
        } catch(error) {
            captureException(error);
        }
    }

}

/*
* [
 * { "id": 1, "parent_id": null, "remote_id": "4286", "ordering": "1527238472", "tooth_id": "26", "state_id": "906", "state_pid": "27", "title": "Tömés - kicsiiiii", "title_animation": "Kis tömés", "amount": 1, "unit_price": 11, "price": 11, "batch_price": "0", "animate": "1", "billable": "1", "selected": true },
 * { "id": 1, "parent_id": null, "ordering": 1, "title": "Húzás - normál", "title_animation": "Foghúzás", "state_pid": "33", "state_id": 33, "amount": 1, "tooth_id": "38", "unit_price": 15000, "batch_price": 0, "billable": "1", "animate": "1", "price": 15000, "jaw": "lower" } ]
 *
 *
 * [ { "id": 1, "parent_id": null, "ordering": 1, "title": "Húzás - normál", "title_animation": "Foghúzás", "state_pid": "33", "state_id": 33, "amount": 1, "tooth_id": "28", "unit_price": 15000, "batch_price": 0, "billable": "1", "animate": "1", "price": 15000, "jaw": "upper", "selected": true } ]
 *
 *
*
* */

export default TreatmentStepHelper;
